import { getUnitsByFeatures } from './units';

/**
 * Beräknar data för valda områden och units
 * @param {Array} selectedAreas - Array av GeoJSON features
 * @param {Array} units - Array av units att filtrera och beräkna på
 * @param {Object} salesDistrictFilters - Optional: Filter object med unitsIncludeExclude
 * @param {Array} allUnitsOriginal - Optional: Original allUnits array för att hitta inkluderade units
 * @returns {Object} { area, numberOfUnits, turnOver, retailArea }
 */
export function calculateDistrictData(selectedAreas, units, salesDistrictFilters = null, allUnitsOriginal = null) {
    if (!selectedAreas || selectedAreas.length === 0) {
        return {
            area: 0,
            numberOfUnits: 0,
            turnOver: 0,
            retailArea: 0
        };
    }

    // Beräkna total area från alla valda områden
    const area = selectedAreas.reduce((sum, feature) => {
        return sum + (feature.properties?.area || 0);
    }, 0);

    // Hämta units som ligger inom de valda områdena
    let filteredUnitsInArea = getUnitsByFeatures(selectedAreas, units);
    
    // Lägg till inkluderade units från filtret även om de ligger utanför valda områden
    if (salesDistrictFilters && salesDistrictFilters.unitsIncludeExclude && salesDistrictFilters.unitsIncludeExclude.length > 0) {
        const included = salesDistrictFilters.unitsIncludeExclude.filter(inc => inc.include);
        if (included.length > 0) {
            const unitsToSearch = allUnitsOriginal || units;
            included.forEach(inc => {
                const unit = unitsToSearch.find(u => u.delfiId === inc.delfiId);
                if (unit && !filteredUnitsInArea.find(u => u.delfiId === unit.delfiId)) {
                    // Lägg till unit om den inte redan finns i filteredUnitsInArea
                    filteredUnitsInArea.push(unit);
                }
            });
        }
    }
    
    // Beräkna aggregerade värden
    const numberOfUnits = filteredUnitsInArea.length;
    const turnOver = filteredUnitsInArea.reduce((sum, unit) => sum + (unit.turnover || 0), 0);
    const retailArea = filteredUnitsInArea.reduce((sum, unit) => sum + (unit.retailArea || 0), 0);

    return {
        area,
        numberOfUnits,
        turnOver,
        retailArea
    };
}

